@if (isSearching) {
  <div class="flex items-center justify-center">
    <mat-spinner />
  </div>
} @else {
  <div class="m-4 flex flex-col justify-center gap-2" [ngClass]="innerClass">
    @for (item of items; track $index) {
      <button type="button" mat-stroked-button class="!h-auto min-h-12 !justify-start text-left" (click)="select(item)">
        <div class="flex flex-col items-start py-1">
          <span class="text-base">{{ item.display }}</span>
          @if (item.displaySecondary) {
            <small class="text-sm text-gray-500">{{ item.displaySecondary }}</small>
          }
        </div>
      </button>
    } @empty {
      <span class="text-center">{{ nullMessage }}</span>
    }
  </div>
}
